import {
    getActivityLog,
    listActivityLogs
} from './queries';
import {
    createActivityLog,
    deleteActivityLog,
    updateActivityLog,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateActivityLog,
    DeleteActivityLog,
    GetActivityLog,
    ListActivityLogs,
    UpdateActivityLog,
    ActivityLog
} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {GetActivityLogParser,} from '../schemas/index.ts';
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;

export const fetchRecords = async (query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListActivityLogs>>({
                                                                              query: listActivityLogs,
                                                                              variables: {
                                                                                  ...query
                                                                              },
                                                                          });
    return {
        items: response.data?.listActivityLogs.items,
        nextToken: response.data?.listActivityLogs.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetActivityLog>>({
                                                                            query: getActivityLog,
                                                                            variables: {id: id},
                                                                        });

    const parsed = GetActivityLogParser.parse(response)
    return parsed.data?.getActivityLog;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateActivityLog>>({
                                                                               query: createActivityLog,
                                                                               variables: {input: payload},
                                                                           });
    console.debug('in the service response', response);
    return response.data?.createActivityLog;
};

export const update = async (id: string, record: ActivityLog) => {

    console.debug('IN UPDATE', id, record);

    const response = await client.graphql<GraphQLQuery<UpdateActivityLog>>({
                                                                               query: (updateActivityLog),
                                                                               variables: {input: record},
                                                                           });
    return response.data?.updateActivityLog;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteActivityLog>>({
                                                                               query: (deleteActivityLog),
                                                                               variables: {input: {id: id}},

                                                                           });
    return response.data?.deleteActivityLog;
};
